export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_14.7d052305.jpg";